module.exports = __webpack_public_path__ + "img/referenceBg.8fd6fe7e.png";